import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  container: (isActive = false, isStatic = false) => ({
    position: isStatic ? 'static' : 'fixed',
    width: '100%',
    height: isActive || isStatic ? 33 : 0,
    zIndex: isStatic ? theme.zIndex.documentUp : theme.zIndex.barUp,
    top: 0,
    left: 0,
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    font: theme.fonts.uniformMedium,
    color: theme.rawColors.neutralWhite,
    backgroundColor: theme.rawColors.darkGrey700,
    borderBottom: `1px solid ${theme.rawColors.darkGrey600}`,
    transition: `transform ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}`,
    transform: isActive ? 'translateY(0)' : 'translateY(-100%)',
    ...reusables.mainTransition('height', theme.transitions.animation.atomCurve, theme.transitions.time.normal),
    a: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      p: ['0 24px 0 24px', '0 36px 0 36px', '0 48px 0 48px'],
      fontFamily: theme.fonts.uniformMedium,
      fontSize: theme.fontSizes.caption,
      color: theme.rawColors.neutralWhite,
      letterSpacing: theme.letterSpacings.bigCaps,
      span: {
        textDecoration: ['underline', 'unset', 'unset']
      },
      ':hover, :visited': {
        color: theme.rawColors.neutralWhite,
        span: {
          fontFamily: theme.fonts.uniformMedium,
          textDecoration: 'underline'
        }
      }
    },
    svg: {
      mr: '8px',
      mt: '-2px'
    }
  }),
  containerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    p: ['0 24px 0 24px', '0 36px 0 36px', '0 48px 0 48px'],
    fontFamily: theme.fonts.uniformMedium,
    fontSize: theme.fontSizes.caption,
    color: theme.rawColors.neutralWhite,
    letterSpacing: theme.letterSpacings.bigCaps
  },
  desktopOnly: {
    display: ['none', 'none', 'unset']
  }
};